module.exports = __webpack_public_path__ + "static/media/shape0_6.68e8275c.obj";